"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SdkStateDefinition = void 0;
const services_definitions_1 = require("@wix/services-definitions");
exports.SdkStateDefinition = (0, services_definitions_1.defineService)('viewer-core/sdk-state');
//# sourceMappingURL=index.js.map